import { render, staticRenderFns } from "./professionalResult.vue?vue&type=template&id=404495e2&scoped=true&"
import script from "./professionalResult.vue?vue&type=script&lang=js&"
export * from "./professionalResult.vue?vue&type=script&lang=js&"
import style0 from "./professionalResult.vue?vue&type=style&index=0&id=404495e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404495e2",
  null
  
)

export default component.exports